<template>
  <div
    class="app-main-content"
    style="position:relative;"
  >
    <se-detail-workspace
      ref="bookingWorkspace"
      :parent-context="context"
      :open-multiple="true"
      :source="$route.query.menuType === 'overseaTracking' ? 'overseaTracking' : 'endCommerce'"
      @back="backToList"
    />
  </div>
</template>

<script>
import { BookingNewContext } from '@/views/cargo/v0/SeaExport/bookingNewContext'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { findSeaExportJobByNo } from '@/api/seaExport/seaExportJob'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import { cache } from '@/utils/cacheManager'
import lodash from 'lodash'
import seDetailWorkspace from './seWorkspace'

export default {
  name: 'DestinationBusinessSeDetail',
  components: { seDetailWorkspace },
  data() {
    return {
      context: BookingNewContext.getInstance(),
      loading: null
    }
  },
  computed: {
    officeId() {
      return this.$store.getters.currentOfficeId
    },
    office() {
      return this.context.office || this.$store.getters.currentOffice
    }
  },
  watch: {
    officeId: {
      async handler(newVal) {
        if (this.office.officeId !== this.officeId) {
          await this.context.prepareData()
        }
      }
    }
  },
  async created() {
    await this.context.prepareData()
    // 加载UICustom配置，确保与源业务类型详情页配置一致
    if (Number(cache.hqConfig.get('UICustomization')) === 1) {
      const branchId = this.$store.getters.currentOfficeId
      await UICustomUtil.loadUICustomPageInfo('/DestinationBusiness/SeDetail', branchId)
    }
  },
  async mounted() {
    // 从尾程商务列表跳转过来：通过 query.key (jobNo) 加载详情
    const jobNo = this.$route.query.key
    const branchId = this.$route.params.branchId || this.$store.getters.currentOfficeId
    if (!jobNo) {
      this.$message.error(this.$t('Message.JumpFailed'))
      return
    }
    const loading = getLoading4Cxt(this)
    try {
      const res = await findSeaExportJobByNo({ jobNo, branchId, pageNum: 1 })
      let rowData = this.getNewDetailData(res.data.list || [])
      if (rowData.length === 0) {
        this.$message.error(this.$t('Message.NoRecordMeetTheConditions'))
        return
      }
      // 从store获取列表页当前页数据，用于左侧业务编号列表展示
      const storeJobs = this.$store.state.destinationBusiness.currentPageJobs || []
      if (storeJobs.length > 0) {
        // 过滤出SE类型的业务数据
        const seJobs = storeJobs.filter(job => job.lob === 'SE')
        if (seJobs.length > 0) {
          // 合并store数据和API数据，确保选中的job有完整数据
          const mergedData = []
          const apiJobMap = new Map(rowData.map(j => [j.jobNo, j]))
          for (const job of seJobs) {
            const apiJob = apiJobMap.get(job.jobNo)
            mergedData.push(apiJob || job)
          }
          rowData = this.getNewDetailData(lodash.cloneDeep(mergedData))
        }
      }
      const selectedRow = rowData.find(p => p.jobNo === jobNo) || rowData[0]
      let action = 'look'
      if (this.$route.params.action) {
        action = this.$route.params.action
        delete this.$route.params.action
      }
      this.$refs.bookingWorkspace.onShow(action, rowData, selectedRow)
    } catch (err) {
      this.$message.error(this.$t('Message.JumpFailed'))
      throw err
    } finally {
      loading.close()
    }
  },
  errorCaptured(err) {
    if (err instanceof ErrorTip) {
      this.$message({ message: err.message, type: err.type })
      return false
    }
    return true
  },
  methods: {
    // 返回到尾程商务列表页
    backToList() {
      const targetPath = this.$route.query.menuType === 'overseaTracking'
        ? '/DestinationBusiness/OverseaTracking'
        : '/DestinationBusiness/EndCommerce'
      this.$store.dispatch('tagsView/delView', this.$route).then(() => {
        this.$router.push({ path: targetPath })
      })
    },
    getNewDetailData(rowData) {
      rowData = lodash.cloneDeep(rowData)
      for (const item of rowData) {
        new SeaExportJob(item).fillDefaultValue()
        item.version = 0
      }
      return rowData
    }
  }
}
</script>

<style lang="scss">
</style>
